<div>
  <div class="flex justify-between">
    <div class="flex-1">
      <div class="flex mb-7 mt-3 gap-2">
        <div class="flex">
          <div class="relative">
            <app-pan-floating-label>Date From</app-pan-floating-label>
            <app-pan-datepicker [min]="minSelectableDate" [max]="maxDate()" (dateChange)="onMinDateChange($event)" [(date)]="minDate" placeholder="Date from"> </app-pan-datepicker>
          </div>
        </div>

        <div class="flex">
          <div class="relative">
            <app-pan-floating-label>Date To</app-pan-floating-label>
            <app-pan-datepicker [min]="minDate()" [max]="today" (dateChange)="onMaxDateChange($event)" [(date)]="maxDate" placeholder="Date to"> </app-pan-datepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-1 flex justify-end">
      <a
         panButton
         color="info"
         icon="cloud_download"
         [disabled]="soldDetails().length === 0"
         (click)="export()"
         matTooltip="Download sold details"
         data-testid="transactions-export-button"
         >
      </a>
    </div>
  </div>

  <ag-grid-angular #transactionsGrid data-testid="transactions-table" [columnDefs]="columnDefs" [gridOptions]="tableDef" [rowData]="soldDetails()" [loading]="isLoading()">
  </ag-grid-angular>
</div>
